import React from 'react';
import './WhoItsFor.css';

const personas = [
  {
    label: 'L&D Head',
    desc: 'You design the learning strategy. You need to know it\'s working — and that it\'s changing how people perform on the job.',
  },
  {
    label: 'HR Leader',
    desc: 'You\'re responsible for onboarding, compliance, and upskilling. You shouldn\'t need three tools and a spreadsheet to track any of it.',
  },
  {
    label: 'Team Manager',
    desc: 'You know what your team needs to learn. Now you can assign it, track it, and see it change how they work — without going through HR every time.',
  },
];

export default function WhoItsFor() {
  return (
    <section className="who-its-for">
      <div className="who-its-for__container">
        <div className="who-its-for__header">
          <div className="who-its-for__eyebrow">Who it&apos;s for</div>
          <h2 className="who-its-for__heading">
            Built for the people who own learning outcomes.
          </h2>
        </div>

        <div className="who-its-for__grid">
          {personas.map((persona, index) => (
            <div key={index} className="who-its-for__card">
              <div className="who-its-for__label">{persona.label}</div>
              <div className="who-its-for__desc">{persona.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
